import {useQuery} from '@tanstack/react-query';
import axios from 'axios';

// The server answers the signed-in user, so the address names no one (COM-482). The
// user's id stays in the key: the three apps share one origin (COM-457), so two accounts
// on one browser must not share a cached question.
const useGetNextEvaluationQuestion = (userId: number) => {
  const {data, isLoading, error, refetch} = useQuery({
    queryKey: ['evaluation-question', userId],
    queryFn: async () => await axios.get('/api/evaluation/question').then((res) => res.data),
    enabled: !!userId,
    staleTime: 0, // Always refetch to ensure fresh data
  });

  return {data, isLoading, error, refetch};
};

export default useGetNextEvaluationQuestion;
